import React, { Component } from 'react';
import { Button, Form, FormGroup, Modal, Row, Col, Container } from 'react-bootstrap';
import { Snackbar } from '@mui/material';
import { IconButton } from '@mui/material';



import SessionFormationService from '../services/SessionFormationService';
import FormationService from "../services/FormationService";
import AuthService from "../services/LoginService";
import EventBus from "../common/EventBus";


export class AddSession extends Component {


    emptyItem = {
        location: '',
        startDate: '',
        endDate: '',
        formation: {
            id: '',
        }

    };


    constructor(props) {
        super(props);
        this.state = {
            item: this.emptyItem,
            formationId: '',
            formations: [],
            snackbaropen: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.retrieveFormations = this.retrieveFormations.bind(this);
    }

    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveFormations();
        }
    }



    componentDidUpdate(previousProps, currentState) {
        // console.log('In add student componentDidUpdate:::');
        // console.log(this.props.currentsession);
        // console.log('previous');
        // console.log(previousProps.currentsession);
        if (previousProps.currentsession !== this.props.currentsession) {
            // console.log('is diff :::');
            this.setState({ item: this.props.currentsession });
        }
    }

    retrieveFormations() {
        //const { firstNameFilter, lastNameFilter, page, pageSize } = this.state;
        //const params = this.getRequestParams(firstNameFilter, lastNameFilter, page, pageSize);
        FormationService.getAll()
            .then((response) => {
                const { formations } = response.data;

                this.setState({
                    formations: formations,
                });
                //console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });

    }



    handleChange(event) {
        //console.log('In add session handleChange :::');
        //console.log(event);
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };


        if (name === "formationId") {
            // let formationId = { ...this.state.formationId };
            //formationId = value;
            item.formation['id'] = value;
        } else {
            item[name] = value;
        }
        this.setState({ item });

        //console.log('State after change');
        // console.log(item);
    }


    handleSubmit(event) {
        event.preventDefault();
        const { item } = this.state;
        if (item.id) {
            SessionFormationService.update(item.id, event)
                .then((response) => {
                    const {  message } = response.data;
                    //alert(message)
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                })
                .catch((err) => {
                    console.log(err);
                    const {  message } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                });
        } else {
            SessionFormationService.create(event)
                .then((response) => {
                    const {  message } = response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                })
                .catch((err) => {
                    console.log(err);
                    const {  message } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                });
        }

    }

    onChangeStartDate(e) {
        const startDateVal = e.target.value;
        console.log(startDateVal);
        //Moment.locale('en');        
        this.setState({
            startDateFilter: startDateVal,
        });
    }
    onChangeEndDate(e) {
        const endDateVal = e.target.value;
        //Moment.locale('fr');
        console.log(endDateVal);
        this.setState({
            endDateFilter: endDateVal,
        });
    }


    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }

    render() {
        const { item, formations } = this.state;
        //console.log('In render : ');
        //console.log(item);
        const titre = <h2>{item.id ? 'Modifier Session' : 'Ajout Session'}</h2>;

        const formationList = formations.map(formation => {
            return <option key={formation.id} value={formation.id}>{formation.id}-{formation.name}-{formation.payMode}</option>
        });

        //{formationList}
        // { formations.map(formation => <option value={formation.id}>{formation.id}-{formation.name}-{formation.payMode}</option>)}

        return (
            <div className='container'>

                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={this.state.snackbaropen}
                    autoHideDuration={3000}
                    onClose={this.snackbarClose}
                    message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label='Close'
                            color='inherit'
                            onClick={this.snackbarClose}
                        >X</IconButton>
                    ]}
                ></Snackbar>

                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titre}
                        </Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={this.handleSubmit}>
                        <Modal.Body>
                            <Container>

                                <Row>
                                    <Col xs={12} md={12}>
                                        <FormGroup controlId='name'>
                                            <Form.Label>Libellé</Form.Label>
                                            <Form.Control type="text" name='name' onChange={this.handleChange} value={item.name || ''} required placeholder='Libellé session' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <FormGroup controlId='formationId'>
                                            <Form.Label>Formation</Form.Label>
                                            <Form.Select aria-label="Formation" name='formationId' onChange={this.handleChange} value={item.formation.id || ''} required>
                                                <option>Choisir une formation</option>
                                                {formationList}

                                            </Form.Select>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='location'>
                                            <Form.Label>Localisation</Form.Label>
                                            <Form.Control type="text" name='location' onChange={this.handleChange} value={item.location || ''} required placeholder='Localisation de session' />
                                        </FormGroup>
                                        <FormGroup controlId='id'>
                                            <Form.Control type="hidden" name='id' onChange={this.handleChange} value={item.id || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='startDate'>
                                            <Form.Label>Date Debut</Form.Label>
                                            <Form.Control type="date" data-date-format='dd-MM-yyyy' name='startDate' onChange={this.handleChange} value={item.startDate || ''} required />

                                        </FormGroup>
                                    </Col>

                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='endDate'>
                                            <Form.Label>Date Fin</Form.Label>
                                            <Form.Control type="date" format='dd-MM-yyyy' name='endDate' onChange={this.handleChange} value={item.endDate || ''} required />
                                        </FormGroup>
                                    </Col>

                                </Row>



                            </Container>


                        </Modal.Body>
                        <Modal.Footer>
                            <FormGroup>
                                <Button variant="dark" type="submit" >Enregistrer</Button>
                            </FormGroup>
                            <Button variant='danger' onClick={this.props.onHide}>Fermer</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}